import styled from "styled-components";

export const IntroText = styled.p`
	margin-bottom: 1em;
`;

export const FieldContainer = styled.p``;
